// extracted by mini-css-extract-plugin
export var activeDot = "_3s-c";
export var buttonContainer = "_3s-9";
export var channelButton = "_3s-a";
export var clickable = "_3s-d";
export var content = "_3s-0";
export var contentFull = "_3s-2";
export var contentThird = "_3s-1";
export var contentWrapper = "_3s-7";
export var description = "_3s-5";
export var heightShort = "_3s-f";
export var image = "_3s-3";
export var imageContainer = "_3s-4";
export var selectButton = "_3s-e";
export var spinnerContainer = "_3s-b";
export var titleContent = "_3s-8";
export var titleWrapper = "_3s-6";